var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWallet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "none",
  viewBox: "0 0 32 35"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M4.75 16c0-4.352 2.337-7.392 5.97-7.904Q11.277 8 11.876 8h14.25c.37 0 .727.016 1.069.08 3.676.48 6.056 3.536 6.056 7.92v8c0 4.8-2.85 8-7.125 8H15.438M8.313 20.75v9.75m0-9.75 3.562 3.75m-3.562-3.75L4.75 24.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CACACA",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  d: "M27.7 17h4.55a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H27.7a3 3 0 1 1 0-6Z"
})));
export default SvgWallet;